module.exports = __webpack_public_path__ + "img/google.b75aecaf.png";